import { $Q, $Qll } from '../utils/query-selector';
import { createInterception } from '../utils/script-defer';
import { isRegisteredUser } from './news-letters';
import {
  PredictiveSearch,
  handleSearchForm,
  handleClearBtn,
} from '../components/predictive-search';
import { initTopBarSlider } from './top-bar';
import { focusDropDownItem } from './accesibility-dropdown';

const toggleMobileFooter = () => {
  const toggleNodes = $Qll('.js-toggle-active');
  toggleNodes.forEach((node) => {
    node.addEventListener('click', () => {
      const { active } = node.dataset;
      if (active === 'true') {
        node.setAttribute('data-active', 'false');
      } else {
        node.setAttribute('data-active', 'true');
      }
    });
  });
};
const bottonText = () => {
  window.addEventListener('load', (event) => {
    const text = document.querySelectorAll('#reset-search');
    if (text) {
      text.forEach((e) => {
        e.innerHTML += e.title;
      });
    }
  });
};
export const headerFooterDefer = () => {
  const formNewLetter = $Q('#NewsletterForm--footer');

  initTopBarSlider();
  window.customElements.define('predictive-search', PredictiveSearch);
  focusDropDownItem();
  handleSearchForm();
  handleClearBtn();
  bottonText();
  toggleMobileFooter();
  if (formNewLetter) {
    createInterception(formNewLetter, () => isRegisteredUser());
  }
};
